export default __webpack_public_path__ + "static/media/gear.b1f1407e.svg";